/**
 * Supreme Rose svg-button — outline draw on hover for line-style category links.
 */
class SVGButtonElement extends HTMLElement {
  constructor() {
    super();
    this.path = null;
    this.svg = null;
    this.length = 0;
  }

  connectedCallback() {
    requestAnimationFrame(() => this.initButton());
  }

  initButton() {
    const span = this.querySelector('span');
    if (!span) return;

    this.svg = this.querySelector('svg.progress-line');
    this.path = this.svg?.querySelector('rect');
    if (!this.svg || !this.path) return;

    const width = Math.round(this.getBoundingClientRect().width);
    const height = Math.round(this.getBoundingClientRect().height);
    if (width < 2 || height < 2) return;

    this.svg.setAttribute('width', String(width));
    this.svg.setAttribute('height', String(height));
    this.path.setAttribute('width', String(width));
    this.path.setAttribute('height', String(height));
    this.path.setAttribute('x', '2');
    this.path.setAttribute('y', '1');
    this.path.setAttribute('rx', '10');
    this.path.setAttribute('ry', '10');
    this.svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
    this.path.setAttribute('fill', 'none');

    requestAnimationFrame(() => {
      try {
        this.length = this.path.getTotalLength();
        this.path.style.strokeDasharray = `${this.length} ${this.length + 1}`;
        this.path.style.strokeDashoffset = String(this.length);
        this.addEventListener('mouseenter', () => this.animateStroke(0, 750));
        this.addEventListener('mouseleave', () => this.animateStroke(this.length, 750));
        this.addEventListener('focusin', () => this.animateStroke(0, 750));
        this.addEventListener('focusout', () => this.animateStroke(this.length, 750));
      } catch (error) {
        console.warn('SVG outline not ready:', error);
      }
    });
  }

  animateStroke(targetOffset, duration) {
    let start = null;
    const initialOffset = parseFloat(this.path.style.strokeDashoffset) || this.length;

    const step = (timestamp) => {
      if (!start) start = timestamp;
      const progress = Math.min((timestamp - start) / duration, 1);
      const currentOffset = initialOffset + progress * (targetOffset - initialOffset);
      this.path.style.strokeDashoffset = String(currentOffset);
      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  }
}

if (!customElements.get('svg-button')) {
  customElements.define('svg-button', SVGButtonElement);
}
